"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Package = function Package(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.562 15.505l-6.25 3.592a.625.625 0 01-.624 0l-6.25-3.593a.624.624 0 01-.313-.541V9.027c0-.223.119-.43.313-.54l1.66-.955a.312.312 0 01.312 0l6.934 4.018c.097.056.156.16.156.271v1.58a.156.156 0 00.236.135l1.486-.885a.314.314 0 00.153-.27v-1.737a.157.157 0 00-.078-.136L9.372 6.496a.157.157 0 010-.272l2.316-1.331c.193-.11.43-.11.623 0l6.252 3.593a.624.624 0 01.312.542v5.934c0 .224-.12.43-.313.543zm-9.687-1.852a.313.313 0 00-.157-.27L6.61 12.17a.156.156 0 00-.234.135v2.114c0 .112.06.216.157.271l2.109 1.213a.156.156 0 00.234-.136v-2.114z"
  }));
};

var _default = (0, _react.forwardRef)(Package);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Package, "Package", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Package.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Package.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();